import React, { useState } from "react";
import styles from "../topology.module.scss";
import { Button, Modal, Tooltip } from "antd";
import { setResultModalVisible, setResultList } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useDeviceReboot } from "../queries";
import { useTranslation } from "react-i18next";

interface IresultList {
  id: string;
  name?: string;
  message?: string[];
}

const intitalResult = {
  failureDevices: [],
  rebootDevices: [],
  errorDevices: [],
  successDevices: [],
  rebootfailDevices: [],
  rebootSuccessDevices: [],
};

const SettingResultModal: React.FC = React.memo(() => {
  const disp = useAppDispatch();
  const { resultModalVisible, resultList } = useAppSelector((state) => state.topology);

  const { t } = useTranslation();
  const { mutateAsync: deviceRebootMutation, isLoading: deviceRebootLoading } = useDeviceReboot();
  const [showMore, setShowMore] = useState<any>({
    failureDevices: false,
    rebootDevices: false,
    errorDevices: false,
    successDevices: false,
    rebootfailDevices: false,
    rebootSuccessDevices: false,
  });

  return (
    <Modal
      visible={resultModalVisible}
      onCancel={() => {
        disp(setResultModalVisible(false));
        disp(setResultList(intitalResult));
      }}
      destroyOnClose={true}
      centered={true}
      width={"50%"}
      title={t("ISMS.Result")}
      footer={[
        resultList.rebootDevices.length ? (
          <Button
            key="Cancel"
            onClick={() => {
              disp(setResultModalVisible(false));
            }}
          >
            {t("ISMS.Cancel")}
          </Button>
        ) : null,
        resultList.failureDevices.length || resultList.rebootfailDevices?.length ? (
          <Button
            key="Confirm"
            onClick={() => {
              disp(setResultModalVisible(false));
            }}
          >
            {t("ISMS.Confirm")}
          </Button>
        ) : null,
        resultList.rebootDevices.length ? (
          <Button
            key="Reboot"
            type="primary"
            loading={deviceRebootLoading}
            onClick={() => {
              let DeviceID = resultList.rebootDevices.map((item: IresultList) => item.id);
              // disp(RebootDevice(DeviceID, level, stateCid, t, isUpdate));
              deviceRebootMutation(DeviceID);
              disp(setResultModalVisible(false));
              disp(
                setResultList({
                  failureDevices: [],
                  rebootDevices: [],
                  errorDevices: [],
                  successDevices: [],
                  rebootfailDevices: [],
                  rebootSuccessDevices: [],
                })
              );
            }}
          >
            {t("ISMS.Reboot")}
          </Button>
        ) : null,
      ]}
    >
      <div className={styles.rebootWording} style={{ marginBottom: "30px" }}>
        <h2>
          {t("ISMS.Total submitted")} : {resultList?.total}
        </h2>
      </div>
      {resultList.failureDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {t("ISMS.No Response")} : {resultList.failureDevices.length}
          </h2>
          <p>
            {resultList.failureDevices.map((item: IresultList, index: number) => (
              <span
                key={index}
                className={styles.rebootdevice}
                style={!showMore.failureDevices && index >= 5 ? { display: "none" } : {}}
              >
                {item.name !== "" ? item.name : item.id}
              </span>
            ))}
          </p>
          {resultList.failureDevices?.length > 5 && (
            <span
              className={styles.showMore}
              onClick={() => {
                let failureDevices = !showMore.failureDevices;
                setShowMore({ ...showMore, failureDevices });
              }}
            >
              {showMore.failureDevices && resultList.failureDevices?.length > 5
                ? t("ISMS.show less")
                : t("ISMS.show more")}
            </span>
          )}
        </div>
      ) : (
        ""
      )}

      {resultList.rebootDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {" "}
            {t("ISMS.Need reboot to update setting")}: {resultList.rebootDevices.length}
          </h2>
          <p>
            {resultList.rebootDevices.map((item: IresultList, index: number) => (
              <span
                className={styles.rebootdevice}
                key={index}
                style={!showMore.rebootDevices && index >= 5 ? { display: "none" } : {}}
              >
                {item.name !== "" ? item.name : item.id}
              </span>
            ))}
          </p>
          {resultList.rebootDevices?.length > 5 && (
            <span
              className={styles.showMore}
              onClick={() => {
                let rebootDevices = !showMore.rebootDevices;
                setShowMore({ ...showMore, rebootDevices });
              }}
            >
              {showMore.rebootDevices > resultList.rebootDevices?.length ? t("ISMS.show less") : t("ISMS.show more")}
            </span>
          )}
        </div>
      ) : (
        ""
      )}

      {resultList.errorDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {t("ISMS.Fail")}: {resultList.errorDevices.length}
          </h2>
          <p>
            {resultList.errorDevices.map((item: IresultList, index: number) => (
              <Tooltip title={item?.message?.map((error) => JSON.stringify(error))} key={index}>
                <span
                  className={styles.rebootdevice}
                  style={!showMore.rebootdevice && index >= 5 ? { display: "none" } : {}}
                >
                  {item.name !== "" ? item.name : item.id}
                </span>
              </Tooltip>
            ))}
          </p>
          {resultList.errorDevices?.length > 5 && (
            <span
              className={styles.showMore}
              onClick={() => {
                let errorDevices = !showMore.errorDevices;
                setShowMore({ ...showMore, errorDevices });
              }}
            >
              {showMore.errorDevices && resultList.errorDevices?.length > 5 ? t("ISMS.show less") : t("ISMS.show more")}
            </span>
          )}
        </div>
      ) : (
        ""
      )}

      {resultList.successDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {t("ISMS.Success")}: {resultList.successDevices.length}
          </h2>
          <p>
            {resultList.successDevices.map((item: IresultList, index: number) => (
              <span
                className={styles.rebootdevice}
                key={index}
                style={!showMore.successDevices && index >= 5 ? { display: "none" } : {}}
              >
                {item.name !== "" ? item.name : item.id}
              </span>
            ))}
          </p>
          {resultList.successDevices?.length > 5 && (
            <span
              className={styles.showMore}
              onClick={() => {
                let successDevices = !showMore.successDevices;
                setShowMore({ ...showMore, successDevices });
              }}
            >
              {showMore.successDevices && resultList.successDevices?.length > 5
                ? t("ISMS.show less")
                : t("ISMS.show more")}
            </span>
          )}
        </div>
      ) : (
        ""
      )}

      {resultList.rebootfailDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {t("ISMS.Reboot")} - {t("ISMS.No Response")} : {resultList.rebootfailDevices?.length}
          </h2>
          <p>
            {t("ISMS.Device")}:
            {resultList.rebootfailDevices.map((item: IresultList, index: number) => (
              <span
                key={index}
                className={styles.rebootdevice}
                style={!showMore.rebootfailDevices && index >= 5 ? { display: "none" } : {}}
              >
                {item.name !== "" ? item.name : item.id}
              </span>
            ))}
            {resultList.rebootfailDevices?.length > 5 && (
              <span
                className={styles.showMore}
                onClick={() => {
                  let rebootfailDevices = !showMore.rebootfailDevices;
                  setShowMore({ ...showMore, rebootfailDevices });
                }}
              >
                {showMore.rebootfailDevices ? t("ISMS.show less") : t("ISMS.show more")}
              </span>
            )}
          </p>
        </div>
      ) : (
        ""
      )}

      {resultList.rebootSuccessDevices?.length ? (
        <div className={styles.rebootWording}>
          <h2>
            {" "}
            {t("ISMS.Reboot")} -{t("ISMS.Success")}: {resultList.rebootSuccessDevices.length}
          </h2>
          <p>
            {t("ISMS.Device")}:
            {resultList.rebootSuccessDevices.map((item: IresultList, index: number) => (
              <span
                key={index}
                className={styles.rebootdevice}
                style={!showMore.rebootSuccessDevices && index >= 5 ? { display: "none" } : {}}
              >
                {item.name !== "" ? item.name : item.id}
              </span>
            ))}
            {resultList.rebootSuccessDevices?.length > 5 && (
              <span
                className={styles.showMore}
                onClick={() => {
                  let rebootSuccessDevices = !showMore.rebootSuccessDevices;
                  setShowMore({ ...showMore, rebootSuccessDevices });
                }}
              >
                {showMore.rebootSuccessDevices && resultList.rebootSuccessDevices?.length > 5
                  ? t("ISMS.show less")
                  : t("ISMS.show more")}
              </span>
            )}
          </p>
        </div>
      ) : (
        ""
      )}
    </Modal>
  );
});

export default SettingResultModal;
